<template>
    <div class="">
        <div class="accounts transitionBody">
            <div class="accounts-head"><img
                @click="back()"
                    src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAABQCAMAAABVumeJAAAAV1BMVEUAAAAXIkohIUcdJEgdJEgdJUgmJlMdJEkcJUgdJUgdJUgcJUgZJUgdJUgdJUgdJEgdJUcdJUghIUccJEgdJUgfKUcdJEgeJUgdJ0UdJUgdJkccJkwdJUhEH/ptAAAAHHRSTlMACw/KxcIGEby3qs0UntXY0KMXsPAZlWca5nobAFu9RgAAAJ1JREFUSMft10kSgjAQQNEmCWICMSJBHHL/czpsuspNd1fJnL9+F/jAqvAxOcW0ZXqnFdN+8wKbIsOahJht05WyCq0t1mWP2TKtzvbHlluz1RJsne2nBq2hLDiBBYlFbA80biVamRG1nkR3u9CO1pVM19No+LNuzqvX7cz6tBR9Qe03rMN4ukc9SLQFultAzNcDcHoGfBq6vov3B8AL7dpTX/nqleQAAAAASUVORK5CYII="
                    style="width: 11px; height: 20px;">
                <div class="accounts-head-text"> 我的钱包 </div>
                <div class="accounts-details" @click="go('/transRecord')"> 账户明细 </div>
            </div>
            <div class="vue-slim-better-scroll">
                <div class="vue-slim-better-scroll__wrapper" style="transition-duration: 0ms;">
                    <div style="pointer-events: auto;">
                        <div class="accounts-scroll">
                            <div class="topArea">
                                <div class="topArea_card">
                                    <div class="card_top">
                                        <div class="card_top_left"><img
                                                src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAcJJREFUWEftl7FLHFEQh7+fJArGJgR7QSGWiqRJGv+E2KmNhcSIdtoddkECgXSJeInYCYJ2likDgUjUThsLC0UIwUpFTeLoLHtwnLd7x91bTuRet7x9v/l23szsjADM7BEwBYwBzwF/DrV+A0OStsoJKja+BrwOZbGMTl7SZBLANPAJOAM+AMcBQXJAF/BF0tskgG2gH5iTNB/QuF/tL2CgEsAp8ASYkPS1EQAXQBvwRtJSYIBN4AWwIMmv+s7yICwAfAf2QgJ49AOdsa7rFy8D8sUAgW1XJXfYaIDLJkDTAw/SA17a14EToDuuBT0JSRk0C/4CM7eF57MkLzLRMrN24F28V8oRFCAn6X1S+TGzFWC0ZD8YwKG7W9JVCoBfxy7QWvROMIBVSSOViq+Z+b+mNwuAZUnjVQDsAH1ZAPyQ9CoNwMw6gAPgWRYA18BLST9TYsBbssWsgtB194FBSUelEGbmbdk34GmWAK7tDa3n/AbwJ25Ih4FZwK8g0zpQLP4P+A88BlpSYiNYGlZKgKT9+wFQaMtr/Yp6zkUeKAwm9QjVejYCKIxmtYrUcy4C8Ek46+E0CfJcvpPxeJ5k3NP04w3Z2OyuA0ahogAAAABJRU5ErkJggg=="><span>账户总资产</span>
                                        </div>
                                        <div class="nums_box">
                                            <div class="left-nums">{{ $store.state.userInfo.balance * 1 + $store.state.userInfo.gameblance * 1 }}</div>
                                            <div class="refresh"><img
                                                    src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAaCAYAAACgoey0AAAAAXNSR0IArs4c6QAAAvpJREFUSEutlluITWEUx39/zIQoIsUkJolIIUPkLiJFHsRIKdMkxQtKE1IiUoqUB2USTWYGhUQSSrnlFuUauURKrrk8uC17nfnOtGc7t3Fm1anT3mut3/7W9RMFipkNBBYCkwH/3xP4BXwEHgFngHpJrwtxqXxKZjYA2A7MA/Lp/wQOAeskvcrlO6cjM1sC7InAnfN9YOL9Z2ClpIPZ7PKB3wE9YsbXgAbgCvAGMKAMGBfSMCoBqpG0LRM8H/gYMBd4BlRLOpfr5GY2HdgL9I/pLZPkz1pIPnAJMCaC35b0rZBwm1l34AQwPuh73kdIuhe3bwE2s/b+UtLvQiDZdMysE3AZGB50LkqalAu80fMmaVMxYLc1s3LgPtAx+Jom6Xzab/OJg+KDUDBDJHleixIz88JaG5w0SlqQCexfMyW8uCBpalHUplP3BZ4D7YCv3iGSfqTSGcKyFNiXAFVJqm0D+C0vruCnQtKNFNjMeoWR1y0B+RRNoUGS3hYDN7P9UTv6IHKplFSfBnuvzgI6hJD4c69q/52S5KOy1WJmvaPR6a1UA6wKDtYAB5zlJ+4aFFZHDzYHhS3hf4mkL62mNuW3DlgUijU5L47Eq7o6TB3n1Eqq+h9g2sbMPHW+tTyVcXmfSmFM0as4PRJ9Uo0sBhyKdj7QmPCzWFJdHOwh96VQGsJTLulFG8BPArODn7OSZqSKK+7YzE4DM8OzHZK8GIoSM+sTQu7jeLCkl5nAvom8yl280YdKelIUuanQvHBLJW1N+/pnO5nZzWi7pPN7N7rSjJX0vVh40j4TuCIK99VYT18C5kj6UAg8tGeZpIe59DPuYzNbEc3V3TFDL7LlkrwGsoqZeRXvjNrS87peks+DjJL1ImBmG6JTJ9fjHeAo4FHwy5zb+4SaADh0WIxyXdLoVoPdwMx8eewCuhQS5piObyLv1+P/BQ7wfoBXo5/I53ku+RN1wmHfwflmQL57cjMkXBQqgYnej2EU+i3TR+Dj6Lnv8wZJTwuJzl/alPrprg+vsQAAAABJRU5ErkJggg==">
                                            </div>
                                        </div>
                                    </div>
                                    <div class="card_bottom">
                                        <div class="account_money"> 主账号余额<span> {{ $store.state.userInfo.balance * 1 + $store.state.userInfo.gameblance * 1 }} </span></div>
                                        <div class="take_back" @click="transall"><img
                                                src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAAAXNSR0IArs4c6QAABEJJREFUSEudl1nMXlMUhp/XHBdmYooUEUokGmKosUgR6sIFqTR+Go2hVPxFREiEiIuW0ISGFjGLXjQxhRiibWhjjJkGoTFETYl5Xs77ZZ3f6f7ON/zW1fftvfZ+9xrfdcSQEhE7A9OAKcAewDbARsCPwMfAS8BTwAuS/hl0rQYpRMTBwJXAVGDDQfrAh8DNwO2S/uil3xM4IrYEbqqsOWMIsDaV94ERSfZEl7QCR8RewBPArsUJu/AN4E3gc+BvYCdgH+AAYP1C/y/gIkm3lshdwBGxbxXHZZW7bHEt3wALgHskfdpmQUT4ASMGArYrdC6VNL+5tg5wROwCvFwcvBe4WNK3w7g8IrYCbsxHNI9Ml/RQvVACrwIOamjPleRLxi0RcTlwfePgTw6JpDVeGwOOiPMqS5ux6HLPeNEj4jrgisa5xyWdNAYcERsDnwDbp9ISSaeWQBFxFLBGkut2TCJiT5+V5NxYRyJiOXB4Y3GypJUdiyNiBuBYWn4GJkhyQjUvd+N4DvgBOFaSc8Fnj8wK2LTaP0LSiuKck9VVUMuDkk6vgR+rkurE3Jkn6bKWl++QpbRtdis/xJ56GjDoF8AkSWsLYOssBU7I9V+BrZVutvJmueEEeLcETuv2Bp4HDP5d1u3mCTqlsmR1fa5y8dHuXlnnmxT3TTWwF51UjulaSbu1gTYudLN4pKrpWs9g05qg+Ug3kwurJnNV1QNcYk25pJnVW1ihTJwG4FlVAp4JuHu5WZgoLB8AXwLrZYO5o3C1QV1aszMk3r56IEk0gN8D3Er7yWpJzvAuiQhXjD0w3fVtV8/0C4AbgIW9GCUi9gdOy9qfBByTtz8LvJ6ecBm+MuBxnW0DOwbXpLKtGpX0ZHk4Itx/J+f68ZV7z8nftwHWdwhWlVnd8NihwFeSTJsd4LOrmC0qgEzoc4ostSW2up+8Ksks1eZqs9mOWZKjBrbbXmvR/S359GHvRcQ84NzU80Dg+rT8DvyZvxdJGm3xluNufq6lU07Oxs8ANwiLWejarNNldVNP8A1S5/ycMvzXNNjp8ZLMv23Wmiyc2ZZfOg0kLzRXzs2NAA6T9GLbJalvyxfm/gWSbumja143D9QNypw+UgN70nDQbb3lHWC/Pha45u/LDJ8h6fs+wHcX49OB7vPNBmJ3mRprWSxpVq8Lh1mPCIek6Y2lkk7phKW+ICLcc22pu1ItCyprHMNxSwu/m9UmSjKZ/AecsfMoa1qrk8jLbhAzm0nW7xU5nTqZ6jqv1U+W9Gj9p23YsytcQs2J0WPLYuBOSW+1AUeEScO8PsdZW+jMLifNXuOtO9P9Lazi+z5KYv86u5VBzFgTSw9m6cyS9ED52H4DvSfOuwDz6v8Rl6NDZPbqkoHsFBHH5cDmuWmgfn5DzZe0pN9rh7mocz4iJlQk4BAcUs1nu+dHm8+7hj3kr6wazzOS3h7GPf8ChWCBSpzVXz0AAAAASUVORK5CYII=">
                                            一键取回 </div>
                                    </div>
                                </div>
                                <div class="venuesDetail">
                                    <div class="venues">
                                        <van-switch v-model="checked2" size="18px" active-color="#3084ff" inactive-color="#d9dbe7"/>
                                        <div class="left-nums">场馆余额明细</div>
                                    </div>
                                    <div class="venuesList" v-show="checked2"><!---->
                                        <div class="listbox">
                                            <div class="item" v-for="(item, index) in balancelist" :key="index">
                                                <div class="inner-box">
                                                    <div class="out"><span class="tittleText">{{ item.name }}</span><img
                                                        v-if="index==0||index==3||index==9||index==11"
                                                            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAWCAMAAADzapwJAAAA9lBMVEUAAABedrJtgLNGYqRSbKlxiLtnfrVMZ6ZKZqVKY6VZb6Zra8Bddq9ac65ierJPaqhthblYca1LZqVGYqJthLlKZqZqgbdGYqNyh7tVbqtgeLFpgbdof7ZshLlyiLpGYqNuhbhvgrpLaaVyiLtYca1TbapMaaZQa6lQa6lddq9KZqVYca1feLFKZqVyiLtpgLZfeLFyiLtvhblRa6pMaKZOaadVcKtherJedq9UcKtHYqVed7FZcK1TbaplfbRUbKtlfbVdda9ZdK9kerFlfbJed7Bje7NZcq5PaqhLZ6ZuhLpIZKRTbapVb6trgrhpgLZnfrVwh7tWJ9QBAAAARXRSTlMABxD0HPLyeyMTCwT28+bk49nX187KyLSzs66FgHhrayAbEfn49fTx8Ojo5+Li4drZ19HR0MS5sqmCgm9tbGpqYGBWRStgXljDAAAA0klEQVQY013MRaLCQBBF0dcdIwR3t+/uLjjBZf+bAdJVQc7o1hsUlEY1m9S0ZLZqY0d8axOiWUEQPT3ZkwjQejc6cO3tIk3n+StFYvvHGipR23mjtIDGJfWLCEQpL2w0p+xs6vtDfsbev/zMI+4qp7/AjUviCFN1dOguCyPUV64+0e6zEB45f1Dw51t8DEgXkQh3Af+cQdkrcrcgzaXHdJzSkpgSKC+UzMOClQCIzPxISmCjHhsfiNXgqaf21+caiCgaK2KUBXZkJfdknNznKhKeNRAAXw9RAFRhAAAAAElFTkSuQmCC"
                                                            class="Popovershow"></div><span class="moneyText">{{ item.balance }}</span>
                                                </div><!---->
                                            </div>
                                            
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="main-menu" v-show="!checked2">
                                <div class="item" @click="go('/recharge')">
                                    <div class="bgbox out-transfer"><img
                                            src="https://ws1003quans3.wjbsails.com/ng/h5_static/img/zhanghu.65be28e7.png"></div>
                                    <span>账户充值</span>
                                </div>
                                <div class="item" @click="go('/withdrawal')">
                                    <div class="bgbox cash-out"><img
                                            src="https://ws1003quans3.wjbsails.com/ng/h5_static/img/cunkuan.ec404f3f.png"></div>
                                    <span>账户提现</span>
                                </div>
                                <div class="item" @click="go('/transfer')">
                                    <div class="bgbox venues-transfer"><img
                                            src="https://ws1003quans3.wjbsails.com/ng/h5_static/img/zhuanzhang.83be148e.png">
                                    </div><span>场馆转账</span>
                                </div>
                                <div class="item">
                                    <div class="bgbox out-transfer"><img
                                            src="https://ws1003quans3.wjbsails.com/ng/h5_static/img/xiaxian.b53b1ff6.png"></div>
                                    <span>下线转账</span>
                                </div>
                            </div>
                        </div>
                    </div> <!---->
                </div>
                
            </div>
        </div>
    </div>
</template>
<script>
export default {
  name: 'money',
  data() {
    return { daoTime: null, balancelist: [] , checked2:true};
  },
  created() {
    let that = this;
    that.getbalancelist();
    that.daoTime = setInterval(() => {
      that.getbalancelistNoLoding();
    }, 3500);
  },
  methods: {
    back(){
        window.history.go(-1)
    },
    go(s){
        this.$router.push(s)
    },
    transall() {
      let that = this;
      that.$parent.showLoading();
      that.$apiFun
        .post('/api/transall', {})
        .then(res => {
          that.showTost(1, res.message);
          that.getbalancelist();
          that.refreshusermoney();
          that.$parent.hideLoading();
        })
        .catch(res => {
          that.$parent.hideLoading();
        });
    },
    getbalancelist() {
      let that = this;
      that.$parent.showLoading();

      that.$apiFun
        .post('/api/balancelist', {})
        .then(res => {
          if (res.code !== 200) {
            that.$parent.showTost(0, res.message);
          }
          if (res.code === 200) {
            that.balancelist = res.data;
            let balancelist = res.data;
            that.balancelist = balancelist;
          }
          that.$parent.hideLoading();
        })
        .catch(res => {
          that.$parent.hideLoading();
        });
    },
    getbalancelistNoLoding() {
      let that = this;

      that.$apiFun
        .post('/api/balancelist', {})
        .then(res => {
          if (res.code !== 200) {
            that.$parent.showTost(0, res.message);
          }
          if (res.code === 200) {
            that.balancelist = res.data;
            let balancelist = res.data;
            that.balancelist = balancelist;
          }
        })
        .catch(res => {});
    },
    refreshusermoney() {
      let that = this;
      that.$apiFun.post('/api/refreshusermoney', {}).then(res => {
        that.$parent.hideLoading();
        if (res.code == 200) {
          localStorage.setItem('userInfo', JSON.stringify(res.data));
          that.$store.commit('changUserInfo');
        }
      });
    },
  },
  mounted() {
    let that = this;
  },
  updated() {},
  beforeDestroy() {
    let that = this;
    if (that.daoTime) {
      clearInterval(that.daoTime);
    }
    that.daoTime = null;
  },
};
</script>
    
<style scoped lang="scss">
.accounts {
    width: 100%;
    color: #1d2548;
    background-color: #f3f3f6
}

.accounts .accounts-scroll {
    overflow: scroll
}

.accounts .accounts-scroll,.accounts .accounts-scroll .topArea {
    background-color: #fff;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -webkit-flex-direction: column;
    -ms-flex-direction: column;
    flex-direction: column
}

.accounts .accounts-scroll .topArea {
    border-radius: .13333rem;
    box-sizing: border-box;
    padding-top: .42667rem;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center;
    color: #fff
}

.accounts .topArea_card {
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -webkit-flex-direction: column;
    -ms-flex-direction: column;
    flex-direction: column;
    width: 9.06667rem;
    height: 3.73333rem;
    background: url(/static/img/card_bg.7cb52dd3.png) no-repeat;
    background-size: cover;
    padding: 0 .42667rem
}

.accounts .card_top,.accounts .topArea_card {
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: justify;
    -webkit-justify-content: space-between;
    -ms-flex-pack: justify;
    justify-content: space-between;
    box-sizing: border-box
}

.accounts .card_top {
    height: 1.6rem
}

.accounts .card_top,.accounts .card_top .card_top_left {
    -webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center
}

.accounts .card_top .card_top_left {
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    font-size: .37333rem
}

.accounts .card_top .card_top_left img {
    height: .42667rem;
    width: .42667rem;
    box-sizing: border-box
}

.accounts .card_top .card_top_left span {
    margin-left: .18667rem
}

.accounts .card_bottom {
    -webkit-box-pack: justify;
    -webkit-justify-content: space-between;
    -ms-flex-pack: justify;
    justify-content: space-between;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center;
    height: 2.02667rem
}

.accounts .card_bottom,.accounts .card_bottom .account_money {
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex
}

.accounts .card_bottom .account_money {
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -webkit-flex-direction: column;
    -ms-flex-direction: column;
    flex-direction: column
}

.accounts .card_bottom .account_money span {
    font-size: .42667rem;
    font-weight: 500
}

.accounts .card_bottom .take_back {
    width: 2.26667rem;
    height: .64rem;
    background: hsla(0,0%,100%,.3);
    border-radius: 2.66667rem;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center
}

.accounts .card_bottom .take_back img {
    width: .4rem;
    height: .4rem;
    margin-right: .05333rem
}

.accounts .accounts-head {
    height: 1.17333rem;
    line-height: 1.17333rem;
    background: #fff;
    padding: 0 .26667rem;
    border-bottom: .02667rem solid #eceff6;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: justify;
    -webkit-justify-content: space-between;
    -ms-flex-pack: justify;
    justify-content: space-between;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center
}

.accounts .accounts-head img {
    height: .88rem;
    border-radius: .53333rem;
    margin-top: .13333rem
}

.accounts .accounts-head .accounts-head-text {
    font-size: .48rem;
    margin-left: .26667rem;
    color: #1d2548
}

.accounts .accounts-head .accounts-details {
    font-size: .4rem;
    color: #1d2548
}

.accounts .new-accounts-nums {
    font-size: .37333rem;
    text-align: left;
    color: #1d2548;
    line-height: .37333rem;
    height: .37333rem;
    margin-left: .42667rem;
    box-sizing: border-box;
    font-weight: 500
}

.accounts .new-accounts-nums img {
    width: .37333rem;
    height: .37333rem
}

.accounts .nums_box {
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center
}

.accounts .nums_box .left-nums {
    font-family: DIN-Bold;
    font-size: .72rem;
    font-weight: 700;
    color: #fff;
    line-height: .77333rem
}

.accounts .nums_box .refresh {
    -webkit-box-flex: 1;
    -webkit-flex: 1;
    -ms-flex: 1;
    flex: 1;
    height: 100%;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center
}

.accounts .nums_box .refresh img {
    width: .4rem;
    height: .34667rem;
    margin-left: .21333rem;
    margin-top: .05333rem
}

.accounts .nums_box .saveMoneyBtn {
    width: 2rem;
    height: .8rem;
    box-shadow: 0 .08rem .10667rem 0 rgba(51,70,130,.2);
    padding: 0;
    background-color: #5691fe;
    border-radius: .50667rem
}

.accounts .nums_box .saveMoneyBtn .van-button__text {
    width: 2rem;
    height: .8rem;
    text-align: center;
    color: #fff;
    line-height: .8rem;
    font-family: PingFang-SC-Medium;
    font-size: .32rem;
    font-weight: 400
}

.accounts .main-menu {
    margin-top: .26667rem;
    width: 100vw;
    height: 2.66667rem;
    background: #fff;
    box-sizing: border-box
}

.accounts .main-menu,.accounts .main-menu .item {
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center
}

.accounts .main-menu .item {
    width: 1.33333rem;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -webkit-flex-direction: column;
    -ms-flex-direction: column;
    flex-direction: column;
    margin-left: .50667rem;
    margin-right: .50667rem
}

.accounts .main-menu .item .bgbox {
    width: 1.09333rem;
    height: 1.09333rem
}

.accounts .main-menu .item .bgbox img {
    width: 100%;
    height: 100%
}

.accounts .main-menu .item span {
    width: 1.33333rem;
    font-size: .32rem;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center;
    margin-top: .26667rem
}

.accounts .new-accounts-list {
    background: #fff;
    padding: 0 .26667rem .26667rem .26667rem;
    -webkit-box-flex: 1;
    -webkit-flex: 1;
    -ms-flex: 1;
    flex: 1
}

.accounts .new-accounts-list .van-swipe-cell {
    height: 1.86667rem;
    margin-bottom: .26667rem
}

.accounts .new-accounts-list .van-swipe-cell .accounts-swipe-cell {
    height: 1.86667rem;
    background-color: #fff;
    box-shadow: 0 .10667rem .10667rem 0 rgba(87,92,115,.1);
    box-shadow: 0 .05333rem .10667rem 0 rgba(87,92,115,.1);
    border-radius: .13333rem;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex
}

.accounts .new-accounts-list .van-swipe-cell .accounts-swipe-cell img {
    width: 1.22667rem;
    height: 1.2rem;
    margin-top: .34667rem;
    margin-right: .34667rem;
    margin-left: .4rem
}

.accounts .new-accounts-list .van-swipe-cell .accounts-swipe-cell .accounts-list-right {
    width: 8rem;
    margin: 0 0;
    font-size: .37333rem;
    color: #2f3242;
    font-family: PingFang-SC-Medium;
    padding-top: .48rem
}

.accounts .new-accounts-list .van-swipe-cell .accounts-swipe-cell .accounts-list-right span {
    font-size: .32rem;
    color: #575c73
}

.accounts .new-accounts-list .van-swipe-cell .accounts-swipe-cell .accounts-list-right span .coinProtocol {
    margin-right: .13333rem;
    padding: .02667rem;
    padding-left: .08rem;
    padding-right: .08rem;
    background-color: #4f8dfe;
    color: #fff
}

.accounts .new-accounts-list .van-swipe-cell .van-swipe-cell__right {
    width: 2.13333rem;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center
}

.accounts .new-accounts-list .van-swipe-cell .van-swipe-cell__right .delete-button {
    width: 2.13333rem;
    background-color: #ff5745!important;
    border: #ff5745!important;
    padding: 0;
    margin: 0;
    text-align: center;
    font-family: PingFang-SC-Medium;
    font-size: .37333rem;
    font-weight: 400;
    color: #fff;
    height: 100%
}

.accounts .new-accounts-list .accounts-opendetails {
    background: #fff;
    text-align: center
}

.accounts .new-accounts-list .accounts-opendetails span {
    width: 3.2rem;
    height: 1.06667rem;
    line-height: 1.06667rem;
    display: inline-block;
    background: #f7f8fd;
    border-radius: .16rem;
    font-size: .37333rem;
    color: #3084ff
}

.mask:after {
    content: "";
    background: hsla(0,0%,100%,.5);
    position: absolute
}

.keyboard,.mask:after {
    width: 100%;
    height: 100%;
    top: 0;
    left: 0
}

.keyboard {
    position: fixed;
    color: #1d2548;
    background: rgba(0,0,0,.5);
    z-index: 22;
    -webkit-transition: opacity 1.5s linear;
    transition: opacity 1.5s linear
}

.keyboard .password_box {
    top: 4.93333rem;
    width: 6.53333rem;
    height: 4.37333rem;
    padding: 0 .26667rem;
    background: #fff;
    border-radius: .4rem;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -webkit-flex-direction: column;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center
}

.keyboard .password_box,.keyboard .password_box:before {
    position: absolute;
    left: 50%;
    -webkit-transform: translateX(-50%);
    -ms-transform: translateX(-50%);
    transform: translateX(-50%)
}

.keyboard .password_box:before {
    content: "";
    top: 0;
    width: 3.2rem;
    height: .13333rem;
    background: #237bff
}

.keyboard .password_box>:first-child {
    font-size: .42667rem;
    font-family: PingFang SC;
    font-weight: 500
}

.keyboard .password_box>:last-child {
    font-size: .37333rem;
    font-family: PingFang SC;
    font-weight: 500;
    color: #2385ff
}

.keyboard .password_box>div {
    margin: .4rem 0;
    width: 6rem;
    -webkit-box-pack: justify;
    -webkit-justify-content: space-between;
    -ms-flex-pack: justify;
    justify-content: space-between;
    padding: 0 .64rem
}

.keyboard .password_box>div,.keyboard .password_box>div>span {
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex
}

.keyboard .password_box>div>span {
    width: .85333rem;
    height: .85333rem;
    background: #ebedf2;
    border-radius: .13333rem;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center
}

.keyboard .password_box>div>span span {
    display: block;
    width: .21333rem;
    height: .21333rem;
    background: #373c4a;
    border-radius: 50%
}

.board_box {
    position: fixed;
    bottom: 0;
    width: 100%;
    height: 5.46667rem;
    padding: .24rem 0;
    background: #f7f7f7;
    -webkit-transition: bottom .2s linear;
    transition: bottom .2s linear;
    z-index: 33
}

.board_box,.board_box .board_left {
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex
}

.board_box .board_left {
    width: 7.54667rem;
    padding: 0 .24rem;
    -webkit-box-pack: justify;
    -webkit-justify-content: space-between;
    -ms-flex-pack: justify;
    justify-content: space-between;
    -webkit-flex-wrap: wrap;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap
}

.board_box .board_left>span {
    width: 2.18667rem;
    height: 1.06667rem;
    font-size: .48rem;
    font-family: DIN;
    font-weight: 700;
    color: #373c4a;
    background: #fff;
    border-radius: .13333rem;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center
}

.board_box .board_left>span:active {
    background: #dfe3ed
}

.board_box .board_left>:nth-child(10) {
    width: 4.64rem
}

.board_box .board_right>:first-child {
    width: 2.18667rem;
    height: 1.06667rem;
    background: #fff;
    border-radius: .13333rem;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center
}

.board_box .board_right>:first-child img {
    width: .53333rem;
    height: .37333rem
}

.board_box .board_right>:first-child:active {
    background: #dfe3ed
}

.board_box .board_right>:last-child {
    width: 2.18667rem;
    height: 3.68rem;
    margin-top: .24rem;
    background: #2385ff;
    border-radius: .13333rem;
    font-size: .42667rem;
    font-family: PingFang SC;
    font-weight: 700;
    color: #fff;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center
}

.board_box .board_right>:last-child:active {
    opacity: .7
}

.fadeIn {
    display: block
}

.down {
    bottom: -50%
}


.venuesDetail .venues {
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    width: 100vw;
    box-sizing: border-box;
    margin-top: .32rem;
    padding-left: .42667rem;
    padding-right: .4rem;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center;
    font-family: PingFang-SC-Medium;
    font-size: .32rem;
    padding-bottom: .32rem
}

.venuesDetail .venues .left-nums {
    margin-left: .16rem;
    color: #2f3242
}

.venuesDetail .venues img {
    width: .90667rem;
    margin-left: .13333rem;
    height: .53333rem
}

.venuesDetail .venuesList .top {
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    height: 1.73333rem;
    background-color: #eef0f8;
    border-radius: .13333rem;
    -webkit-box-flex: 1;
    -webkit-flex: 1;
    -ms-flex: 1;
    flex: 1;
    margin-left: .4rem;
    margin-right: .4rem;
    -webkit-box-pack: justify;
    -webkit-justify-content: space-between;
    -ms-flex-pack: justify;
    justify-content: space-between;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center;
    padding-left: .42667rem;
    padding-right: .4rem
}

.venuesDetail .venuesList .top .left .left-top {
    margin-bottom: .08rem
}

.venuesDetail .venuesList .top .left .left-top img {
    width: .26667rem;
    height: .26667rem;
    margin-right: .08rem
}

.venuesDetail .venuesList .top .left .left-top .main-number {
    font-family: PingFang-SC-Medium;
    font-size: .29333rem;
    font-weight: 400
}

.venuesDetail .venuesList .top .left .money {
    font-family: DIN-Medium;
    font-size: .37333rem;
    font-weight: 700;
    margin-top: .10667rem
}

.venuesDetail .venuesList .top .onClickBack {
    width: 2.66667rem;
    height: .88rem;
    padding: 0;
    background-color: #3084ff;
    border-radius: .13333rem
}

.venuesDetail .venuesList .top .onClickBack .van-button__text {
    width: 1.86667rem;
    height: .8rem;
    text-align: center;
    color: #fff;
    line-height: .8rem;
    font-family: PingFang-SC-Medium;
    font-size: .34667rem;
    font-weight: 500
}

.venuesDetail .venuesList .listbox {
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: horizontal;
    -webkit-box-direction: normal;
    -webkit-flex-direction: row;
    -ms-flex-direction: row;
    flex-direction: row;
    -webkit-flex-wrap: wrap;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    -webkit-align-content: flex-start;
    -ms-flex-line-pack: start;
    align-content: flex-start;
    padding-left: .32rem;
    padding-right: .32rem
}

.venuesDetail .venuesList .listbox .item {
    width: 25%;
    height: 2rem;
    border-bottom: .02667rem solid #dcdcdc
}

.venuesDetail .venuesList .listbox .item,.venuesDetail .venuesList .listbox .item .inner-box {
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
    justify-content: center
}

.venuesDetail .venuesList .listbox .item .inner-box {
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -webkit-flex-direction: column;
    -ms-flex-direction: column;
    flex-direction: column;
    border-right: .02667rem solid #dcdcdc;
    width: 100%;
    padding-left: .08rem;
    padding-right: .08rem
}

.venuesDetail .venuesList .listbox .item .inner-box .out {
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center
}

.venuesDetail .venuesList .listbox .item .inner-box .out .tittleText {
    font-family: PingFang-SC-Medium;
    font-size: .26667rem;
    color: #2f3242;
    font-weight: 400;
    -webkit-flex-shrink: 0;
    -ms-flex-negative: 0;
    flex-shrink: 0
}

.venuesDetail .venuesList .listbox .item .inner-box .out img {
    margin-left: .05333rem;
    width: .32rem
}

.venuesDetail .venuesList .listbox .item .inner-box .moneyText {
    margin-top: .18667rem;
    font-family: DIN-Medium;
    font-size: .29333rem;
    color: #a5a9b3;
    font-weight: 500
}

.venuesDetail .venuesList .listbox .item .desShow {
    min-width: 3.2rem;
    max-width: 3.73333rem;
    background-color: #5c6ea1;
    position: absolute;
    margin-bottom: 2.4rem;
    border-radius: .16rem;
    padding-left: .16rem;
    padding-right: .16rem;
    padding-top: .08rem;
    padding-bottom: .08rem;
    line-height: .48rem;
    margin-left: 1.06667rem;
    z-index: 999;
    border: .02667rem solid #ccc;
    font-size: .26667rem;
    margin-right: .4rem;
    box-sizing: border-box;
    color: #fff
}

.venuesDetail .venuesList .listbox .bbNone {
    border-bottom: none!important
}

.venuesDetail .venuesList .listbox .item:nth-child(4n) .inner-box {
    border-right: none
}

</style>


// WEBPACK FOOTER //
// src/components/account.vue